<template>
  <div class="pb-6" :id="slug">
    <div class="px-4">
      <div class="text-2xl font-bold uppercase">{{ title }} {{ emoji }}</div>
      <div v-if="description" class="text-gray-700 text-sm">
        {{ description }}
      </div>
    </div>
    <div class="flex flex-wrap mt-4 mb-6">
      <slot></slot>
    </div>
  </div>
</template>

<script>
module.exports = {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    emoji: {
      type: String,
    },
  },
  computed: {
    slug() {
      return this.title.replace(/\s+/g, "-").toLowerCase()
    },
  },
}
</script>

<style scoped></style>
